import React, { useEffect, useMemo, useRef, useState } from "react";
import useDisableContextMenu from "../../../hooks/useDisableContextMenu";
// import ReactSWF from 'react-swf';
import "./MediaViewer.css";
import VideoProgressTracker from "./Track";
const VideoStyle = {
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  paddingTop: "2rem",
};

function Video(props) {
  useDisableContextMenu();

   const url = useMemo(() => {
     return props.link || props.location?.useProps?.fileUrl || props.fileUrl;
   }, [props]);

  return (
    <div style={VideoStyle}>
      {/* <h4>{props.location.useProps?.moduleName}</h4> */}
      <video
        width="60%"
        style={{
          marginTop: "2rem",
          border: "3px solid #5ce0d2",
          borderRadius: "5px",
        }}
        controls
        controlsList="nodownload"
      >
        <source src={url} type="video/mp4" />
        <source src={url} type="video/ogg" />
        <source src={url} type="video/swf" />
        Your browser does not support HTML video.
      </video>
      {/* <object width='400' height='400' data={props.location.useProps?.fileUrl} type="application/x-shockwave-flash">
                <param name="movie" value={props.location.useProps?.fileUrl} />
                <embed src={props.location.useProps?.fileUrl} width='400' height='400' plug/>
            </object> */}
      {/* <ReactSWF src={props.location.useProps?.fileUrl} width='400' height='400'/> */}
    </div>
  );
}

export default Video;
